/* eslint-disable react/jsx-pascal-case */
import React, { useEffect } from 'react'
import A_Button from '../A_Button'
import { moleculeLog } from 'utils/logUtil'
import { buttonQueryF, clickF } from 'types/FunctionTypes'

type Props = {
  label: string
  disabled?: boolean
  event: clickF | buttonQueryF
  alert?: boolean // 赤色のボタンかどうか
}

/**
 * 明細側に表示したりする小さいボタン
 *  label: string
 *  disabled?: boolean
 *  event: clickF | buttonQueryF
 *  alert?: boolean // 赤色のボタンかどうか
 * @returns
 */
const M_ButtonNormal = ({ label, event, disabled = false, alert = false }: Props) => {
  useEffect(() => moleculeLog('M_ButtonNormal'))
  return <A_Button variant="contained" color={alert ? 'secondary' : 'primary'} label={label} event={event} disabled={disabled} />
}
export default React.memo(M_ButtonNormal)
